module.exports = __webpack_public_path__ + "img/inst.741f0109.svg";